import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster, toast } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { OpenProvider } from './context/OpenContext';
import { UserExpendedProvider } from './context/UserExpendedContext';
import { PaymentExpendedProvider } from './context/PaymentExpandedContext';
import { FeeSettingsExpendedProvider } from './context/FeeSettingsContext';
import { ProfileProvider } from './context/ProfileContext';
import { initSentry } from './config/sentry';
import axios from 'axios';

initSentry();

// Tag every request from the admin app so the API keeps its refresh-token
// cookie separate from the instructor app (both share one API host).
axios.defaults.headers.common['X-Client-Type'] = 'admin';

// Ensure only one toast is visible at a time by dismissing the previous one before showing a new one
(() => {
  if (!toast.__singleModeInstalled) {
    toast.__singleModeInstalled = true;
    let lastToastId;

    const wrapSingle = fn => {
      return (...args) => {
        if (lastToastId) {
          toast.dismiss(lastToastId);
          lastToastId = undefined;
        }
        const id = fn(...args);
        if (typeof id === 'string') {
          lastToastId = id;
        }
        return id;
      };
    };

    // Monkey-patch common toast creators
    toast.success = wrapSingle(toast.success);
    toast.error = wrapSingle(toast.error);
    toast.loading = wrapSingle(toast.loading);
    toast.custom = wrapSingle(toast.custom);
    toast.promise = wrapSingle(toast.promise);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FeeSettingsExpendedProvider>
      <PaymentExpendedProvider>
        <UserExpendedProvider>
          <OpenProvider>
            <AuthProvider>
              <ProfileProvider>
                <Toaster />
                <App />
              </ProfileProvider>
            </AuthProvider>
          </OpenProvider>
        </UserExpendedProvider>
      </PaymentExpendedProvider>
    </FeeSettingsExpendedProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
